import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#__clip0_1121_3376)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M18.7924 9.39407L19.3339 16.001L13.2778 13.1614L14.9824 11.9969L11.4057 7.48503L9.99829 8.69371C8.87677 9.65686 7.17393 9.52029 6.22397 8.39101L0.973417 2.14929C0.505442 1.59297 0.58207 0.766793 1.14457 0.303964C1.70707 -0.158865 2.54243 -0.0830803 3.01041 0.473235L8.26097 6.71495L9.66839 5.50628C10.8127 4.52353 12.5559 4.68852 13.491 5.8681L17.1666 10.5047L18.7924 9.39407Z",
        fill: "#4F4F4F"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "__clip0_1121_3376" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "16",
          fill: "white"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }